
import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    NumberInput,
    required,
    BooleanInput,
} from 'react-admin';
import ScheduleTitle from './ScheduleTitle';

const ScheduleEdit = props => (
    <Edit title={<ScheduleTitle />} {...props}>
        <SimpleForm>
            <ReferenceInput label="Resource" source="resource_id" reference="resources" validate={[required()]}>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput label="Target" source="target_id" reference="targets" validate={[required()]}>
                <SelectInput source="name" />
            </ReferenceInput>
            <BooleanInput source="enabled" />
            <NumberInput source="max_duration" />
            <TextInput source="rrule" multiline />
        </SimpleForm>
    </Edit>
);

export default ScheduleEdit;